if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    initForms() {
      /** Variables */
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.addToCartForms = this.querySelectorAll(
        "form.product-card__add-to-cart--form"
      );
      if (this.addToCartForms.length > 0) {
        this.addToCartForms.forEach(form => {
          form.removeAttribute("method");
          form.removeAttribute("action");
        });
      }
      this.submitButton = this.querySelector('button[type="submit"]');
      /** Event Listeners */
      if (this.addToCartForms.length > 0) {
        this.addToCartForms.forEach(form => {
          form.addEventListener(
            "submit",
            this.submitAddToCartForm.bind(this)
          );
        });
      }
    }

    submitAddToCartForm(event) {
      event.preventDefault();

      this.submitButton.setAttribute("disabled", "");
      this.submitButton.classList.add("add-to-cart--is-disabled");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(event.target);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart
            .getSectionsToRender()
            .map(section => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.errors) {
            this.handleErrorMessage(response.errors);
            return;
          }

          if (this.cart) {
            this.cart.renderContents(response);
          }

          this.updateCartCounters();
          this.performRecommendations();
        })
        .catch((error) => { console.error(error) })
        .finally(() => {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.classList.remove(
            "add-to-cart--is-disabled"
          );

          const quickCartDrawer = this.closest("quick-cart-drawer");
          if (quickCartDrawer) {
            quickCartDrawer.close();
          }
        });
    }

    async updateCartCounters() {
      const headerCartCounters = document.querySelectorAll('.cart-count-badge');
      const drawerCartCounters = document.querySelectorAll('.cart-drawer__title-counter');
    
      // combine both counters and filter out any null elements
      const cartCounters = [...headerCartCounters, ...drawerCartCounters].filter(counter => counter !== null);
    
      try {
        const response = await fetch(`${routes.cart_url}.json`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });
    
        const state = await response.text();
        const parsedState = JSON.parse(state);
    
        if (cartCounters.length > 0) {
          // update all cart counters with the current item count
          cartCounters.forEach(counter => {
            counter.textContent = parsedState.item_count;
          });
        }
    
        // toggle 'hidden' class on header counters based on the item count
        if (headerCartCounters.length > 0) {
          headerCartCounters.forEach(counter => {
            counter.classList.toggle("hidden", parsedState.item_count === 0);
          });
        }
      } catch (error) {
        console.error("Cart counters could not be updated:", error);
      }
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            this.initForms();

            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
